module.exports = __webpack_public_path__ + "img/gift.d00b60cf.svg";